'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _button = require('./button');

var _button2 = _interopRequireDefault(_button);

var _swapOutButton = require('./swap-out-button');

var _swapOutButton2 = _interopRequireDefault(_swapOutButton);

var _buttonTextSubmit = require('./button-text-submit');

var _buttonTextSubmit2 = _interopRequireDefault(_buttonTextSubmit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MobileLinkSubmit = _react2['default'].createClass({
    displayName: 'MobileLinkSubmit',


    propTypes: {},

    render: function render() {
        var initialBtn = _react2['default'].createElement(_button2['default'], { buttonText: 'EMAIL ME THE LINK', buttonClass: 'm-sign-mobile--send', buttonColor: 'grasshopper' });

        var submitUrl = _hfReactHelper2['default'].urlHelper('info/sendDownloadLink', _hfReactHelper2['default'].HfSites.SITE_CODE_HS);
        var actionBtn = _react2['default'].createElement(_button2['default'], { buttonText: 'SEND', buttonColor: 'grasshopper' });
        var validateFunc = function validateFunc(val) {
            if (!_hfReactHelper2['default'].isValidEmailAddress(val)) {
                return 'Invalid email address.';
            } else {
                return false;
            }
        };
        var swapInChildren = _react2['default'].createElement(_buttonTextSubmit2['default'], {
            actionButton: actionBtn,
            textPlaceholder: 'Enter email address',
            inputName: 'email',
            textClass: 'm-sign-mobile--text-field',
            url: submitUrl,
            divClass: 'm-sign-mobile--send',
            formName: 'mobileLinkFrm',
            validate: validateFunc });
        return _react2['default'].createElement(_swapOutButton2['default'], { initialButton: initialBtn, swapInChildren: swapInChildren });
    }
});
module.exports = MobileLinkSubmit;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/mobile-link-submit.jsx
 ** module id = 709
 ** module chunks = 0
 **/